module.exports = __webpack_public_path__ + "static/media/step6.6594e610.png";